<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
  import WorkOrderTablePropertyCell from "../../../../../../_shared/_modules/work-order-table-property-cell"
  import type { AssignRequesterCustomerDraft, AssignRequesterCustomerRow } from "../../contract"

  let { row }: InboxWorkflowCellProps<AssignRequesterCustomerRow, AssignRequesterCustomerDraft> =
    $props()
</script>

<WorkOrderTablePropertyCell
  addressLabel={row.addressLabel}
  unitLabel={row.unitLabel}
  disabled={row.disabled}
/>
